import { computed, observable } from 'mobx';
// Import viewStore
import ViewStore from 'stores/ViewStore';
import { getMetadata } from 'utils/helpers';

/**
 * Mediahub Class
 */
export default class Mediahub {
  i18n;

  @observable link;
  @observable metadata;
  @observable type;

  constructor(mediahub) {
    this.link     = _.result(mediahub, 'link', '');
    this.type     = _.result(mediahub, 'type', 'mediahub');
    this.metadata = _.result(mediahub, 'metadata', []);
  }

  @computed
  get title() {
    return getMetadata(this.metadata, 'container_name', ViewStore.language);
  }

  @computed
  get description() {
    return getMetadata(this.metadata, 'container_description', ViewStore.language);
  }
}
